import React from "react";
import { NavLink } from "react-router-dom";

function Sidebar({ user }) {
  return (
    <nav
      id="sidebarMenu"
      className="col-md-3 col-lg-2 d-none d-md-flex bg-light sidebar"
      style={{ marginTop: ".5%" }}
    >
      <div className="sidebar-sticky pt-3">
        <ul className="nav flex-column">
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/admin/dashboard"
              activeclassname="active"
            >
              <i className="fas fa-home"></i> Dashboard
            </NavLink>
          </li>

          {user && user.role !== "api-access" && (
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/admin/profile"
                activeclassname="active"
              >
                <i className="far fa-user"></i> Profile
              </NavLink>
            </li>
          )}

          {user && user.role !== "api-access" && (
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/admin/my-locations"
                activeClassName="active"
              >
                <i className="fas fa-map-marker-alt"></i> My Locations
              </NavLink>
            </li>
          )}

          {user && (user.role === "admin" || user.role === "super-admin") && (
            <>
              <h3 className="px-3 mt-4 mb-1 text-muted">Admin</h3>

              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/locations"
                  activeclassname="active"
                >
                  <i className="fas fa-map-marked-alt"></i> Locations
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/rounds/1"
                  activeclassname="active"
                >
                  <i className="far fa-bell"></i> Classes
                </NavLink>
              </li>
            </>
          )}
        </ul>

        {user && user.role === "super-admin" && (
          <>
            <h3 className="px-3 mt-4 mb-1 text-muted">Super Admin</h3>

            <ul className="nav flex-column mb-2">
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/users"
                  activeclassname="active"
                >
                  <i className="fas fa-users"></i> Users
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/logs"
                  activeclassname="active"
                >
                  <i className="fas fa-book"></i> Logs
                </NavLink>
              </li>
            </ul>
          </>
        )}
      </div>
    </nav>
  );
}

export default Sidebar;
